module.exports = __webpack_public_path__ + "media/images/svg/picture-edeadf0f50ab7f1c96a4329e8f1df94c.svg";